import { render, staticRenderFns } from "./TurnPond.vue?vue&type=template&id=bc752aea&scoped=true&"
import script from "./TurnPond.vue?vue&type=script&lang=js&"
export * from "./TurnPond.vue?vue&type=script&lang=js&"
import style0 from "./TurnPond.vue?vue&type=style&index=0&id=bc752aea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc752aea",
  null
  
)

export default component.exports